import React, { useContext, useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from "emotion-theming";

import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { VerifyOtpContext } from "wrapper/VerifyOtpWrapper/context";
import { UserContext } from "wrapper/UserWrapper/context";
import { ExperimentAndSwitchContext } from "wrapper/ExperimentAndSwitchWrapper/context";
import { ApplicationContext } from "wrapper/ApplicationWrapper/context";
import { CommonContextContext } from "wrapper/CommonWrapper/context";
import { ErrorModalContext } from "wrapper/ErrorModalWrapper/context";
import { getBackFrictionData } from "../../../logics/src/utils/getBackFrictionData";
import { doAppendOrReplaceQueryParam, doAppendQueryParam, getPlatform } from "../../../helpers";
import { getHeaderTitle, handleBackButton, checkAllUpiIntentVisibilityOnWeb, checkUpiIntentVisibilityOnWeb, checkIsNewPaymentMethodVisibleOnScreen1, checkSinglePaymentPageEligibility, getToastTimer } from "../helpers";
import { windowScrollToTop } from "helpers/utils/scrollTop";
import { getIsSavedMethodsDisplayed } from "wrapper/PaymentWrapper/dependencies/helper";
import {
  trackCancelPaymentClick,
  trackContinuewithPaymentClick,
  trackBackFrictionScreenRender,
  trackDirectlyRedirectUserToNewPaymentPage,
  trackErrorPageLoad,
} from "layouts/Payment/common/dependencies/tracking";
import { useTimerModal } from "../../../hooks/useTimerModal";
import { get } from "../../../logics/src/utils/helpers";
import { PAYMENT_SCREENS } from "constants/paymentScreens";
import { PAYMENT_FLOWS } from "constants/payment";
import { PAYMENT_MODES } from "../../../constants/paymentModes";
import { initialPaymentInfoState } from "wrapper/PaymentWrapper/dependencies/constants";
import { toLowerCase } from "../../../logics/src/utils/toLowerCase";
import { DEVICE_TYPE, STORAGE_KEYS, TRACKING_EVENTS, NOT_AVAILABLE, PAGE_NAMES } from "constants/index";
import { PAYMENT_ERROR_MESSAGE } from "constants/paymentStatus";
import { loadUpiIntentForWeb } from "../helpers";

import MobHeader from "components/NewMobHeader";
import AllPaymentMethod from "layouts/CheckoutPayment/mobile/AllPaymentMethod";
import { default as AllSavedPaymentMethod } from "layouts/CheckoutPayment/mobile/AllSavedPaymentMethod/Loadable";
import { BottomSheet } from "@nykaa/payment-ui/src/BottomSheet/BottomSheet1";
import UpiTimerScreenMobile from "@nykaa/payment-sdk/src/UpiTimerScreen/mobile";
import { Main, UpiModalWrapper } from "../assets/style";
import { VerifyOTP } from "layouts/VerifyOtp";
import { Wrapper } from "pages/Payment/assets/style";
import { PaymentSeo } from "layouts/PaymentSeo";
import { allTrackingHandlerForApps } from "helpers/utils/trackingHandler";
import { CheckoutSinglePageShimmer } from "./Shimmer";
import { checkIsChromeBrowser } from "helpers/utils/isChromeBrowser";
import { Toast } from "@nykaa/payment-ui/src/Toast/index";
import { getStorageData, removeStorage } from "helpers/utils/storage";
import { usePaymentFailureConfig } from "hooks/usePaymentFailureConfig";
import PollingStatusPage from "pages/PollingStatusPage";
import { localStorageService } from "service/storage";


const CheckoutPayment = () => {
  const theme: Theme = useTheme();
  const history = useHistory();

  const query = new URLSearchParams(history.location.search) as any;
  const platform = getPlatform();
  // not enabling intent experiment if not chrome browser
  const gPayExperiment = checkIsChromeBrowser();

  const { applicationData } = useContext(ApplicationContext);
  const {
    PaymentBackFriction,
    NewPaymentFailure,
    UpiIntentMweb,
    NewPaymentMethodOnPaymentScreen1,
    EDD,
    PollingAnimation
  } = useContext(ExperimentAndSwitchContext);
  const paymentContext = useContext(PaymentContext);
  const { userData } = useContext(UserContext);
  const { canRedirectToNewPaymentScren } = useContext(CommonContextContext);
  const errorModalContext = useContext(ErrorModalContext);
  const openErrorModal = get(errorModalContext, "openErrorModal");
  const {
    isVerifyOtpVisible,
    setIsVerifyOtpVisible,
    sendOtpCallback,
    verifyOtpCallback,
    setIsOtpVerificationRequired,
  } = useContext(VerifyOtpContext);
    const { showFallbackModeSheet, setShowFallbackModeSheet, showPollingScreen } = usePaymentFailureConfig();

  const { isApp } = applicationData;
  const cartInfo = get(paymentContext, "cartInfo");
  const cashFreePaymentGateway = get(cartInfo, "paymentGateway");
  const grandTotal = get(cartInfo, "grandTotal");
  const availablePaymentMethods = get(cartInfo, "availablePaymentMethods");
  const shippingAddress = get(paymentContext, "cartInfo.shippingAddress");
  const walletInfo = get(paymentContext, "walletInfo");
  const paymentInfo = get(paymentContext, "paymentInfo");
  const upiIntentList = get(paymentContext, "upiIntentList");
  const setLoading = get(paymentContext, "setLoading");
  const setVisibleOfferBottomSheet = get(paymentContext, "setVisibleOfferBottomSheet");

  const { isGuest } = userData;
  const flow = get(paymentContext, "flow");
  const loading = get(paymentContext, "loading");
  const isPaymentProcessing = get(paymentContext, "isPaymentProcessing");
  const setIsPaymentProcessing = get(paymentContext, "setIsPaymentProcessing");
  const setIsWalletChecked = get(paymentContext, "setIsWalletChecked");
  const paymentScreen = get(paymentContext, "paymentScreen");
  const setPaymentScreen = get(paymentContext, "setPaymentScreen");
  const walletOtpVerificationRequired = get(paymentContext, "walletOtpVerificationRequired");
  const mobileNumber = get(walletInfo, "contactNumber");
  const orderAmount = get(paymentContext, "orderAmount");
  const isSavedPayment = get(paymentContext, "paymentResponseV2Data.isSavedPayment");
  const cartErrorMessage = get(paymentContext, "cartInfo.cartErrorMessage");
  const newPaymentFailureEnabled = NewPaymentFailure?.experimentEnabled && NewPaymentFailure?.switchEnabled;

  const [savedMethodLength, setSavedMethodLength] = useState(-1);
  const isVerificationRequired = get(walletInfo, "isVerificationRequired"); // for wallet veriffication;
  const isWalletAccordianOpen = get(paymentContext, "isWalletAccordianOpen");

  const isCodMethodSelected = get(paymentContext, "isCodMethodSelected");
  const codHandlingCharge = get(paymentContext, "codHandlingCharge");
  const isPaymentInfoLoading = get(paymentContext, "isPaymentInfoLoading");
  let paymentResponseV2Data = paymentContext?.paymentResponseV2Data;
  let showFallbackModes = paymentResponseV2Data?.showFallbackModes;

  // for showing back friction bootmsheet when user clicks back on payment page
  const [showBackFrictionBottomSheet, setShowBackFrictionBottomSheet] = useState(false);
  // state for Google Pay Intent available on device
  const [isGPayIntentAvailable, setIsGPayIntentAvailable] = useState(false);
  const [isGPayIntentLoading, setIsGpayIntentLoading] = useState(true);
  const [toastConfig, setToastConfig] = useState({});
  const [addressIdNotSame, setAddressIdNotSame] = useState("");
  const [isDeliveryEstimateToastVisible, setIsDeliveryEstimateToastVisible] = useState(false);

  // it is for hide the shipping address box. and show only payment methods.
  const showAllPaymentMethods = checkSinglePaymentPageEligibility({ flow });
  const currentScreen = query.get("screen") || PAYMENT_SCREENS.SAVED;
  const shipTothisAddressClicked = query.get("shipTothisAddressClicked");
  const isCodAvailable = cartInfo?.isCodAvailable;
  let headerAmount = grandTotal;
  let screenTypeForHeader = paymentScreen;
  /**
   * This amount will be shown in header.
   * On new payment screen if user select cod
   * then add cod charges to header.
  */
  if (isCodMethodSelected) {
    headerAmount = grandTotal + codHandlingCharge;
  }

  /**
   * This is for fashion web view.
   */
  if (showAllPaymentMethods) {
    screenTypeForHeader = PAYMENT_SCREENS.ALL;
  }

  const isNewPaymentMethodVisible = checkIsNewPaymentMethodVisibleOnScreen1({
    isExperimentEnable: NewPaymentMethodOnPaymentScreen1.experimentEnabled,
    grandTotal,
    flow,
    availablePaymentMethods,
    isCodAvailable,
    cartErrorMessage,
  });

  const { timerCallback, upiTimerConfig, setUpiDetails } = useTimerModal({
    paymentInfo,
    isGuest,
    theme,
    deviceType: DEVICE_TYPE.MOBILE,
    platform,
    flow,
    setLoading,
  });

  // total amount saving on the order
  const totalSaved = cartInfo?.totalSaved || 0;
  // backfriction bottomsheet configurations data
  const backFrictionData = useMemo(
    () =>
      getBackFrictionData(
        theme,
        totalSaved,
        setShowBackFrictionBottomSheet,
        trackContinuewithPaymentClick,
        trackCancelPaymentClick,
        platform,
        PaymentBackFriction?.experimentEnabled,
        isApp
      ),
      /* eslint-disable react-hooks/exhaustive-deps */
    [theme, totalSaved]
  );
  const mobileBackFrictionConfig = backFrictionData?.mobileConfig;

  /**
   * getting header title  based on payment screen or payment option'.
   */
  const screenConfig = useMemo(
    () =>
      getHeaderTitle(
        flow,
        headerAmount,
        screenTypeForHeader,
        !isPaymentInfoLoading && isNewPaymentMethodVisible
      ),
      /* eslint-disable react-hooks/exhaustive-deps */
    [paymentScreen, headerAmount, flow, isPaymentInfoLoading]
  );

  const headerTitle = screenConfig?.headerTitle;
  const dataTestId = screenConfig?.dataTestId;

  const handleBackButtonClick = () =>
    handleBackButton(flow, paymentScreen, shippingAddress, isApp, PaymentBackFriction);

  const handlebackfrictionModal = () => {
    if (setVisibleOfferBottomSheet) {
      setVisibleOfferBottomSheet(false);
    }
    setShowBackFrictionBottomSheet(true);
    trackBackFrictionScreenRender();
    allTrackingHandlerForApps({ event: TRACKING_EVENTS.PAYMENT_BACK_FRICTION_LOADS, isApp });
  };

  // Handle message query parameter to show error modal
  useEffect(() => {
    const queryMessage = query.get("message");
    if (queryMessage) {
      openErrorModal(PAYMENT_ERROR_MESSAGE.FAILED, queryMessage);
      trackErrorPageLoad({
        error_code: NOT_AVAILABLE,
        error_message: queryMessage,
        interaction_location: PAGE_NAMES.PAYMENT_PAGE,
      });
    } 
  }, []);

  /* We are fetching ADDRESS_ID_NOT_SAME from localStorage in checkout page to show the toaster for edd
  We are removing from localStorage after showing toast for one time
  */
  useEffect(() => {
    setAddressIdNotSame(localStorageService.getItem("ADDRESS_ID_NOT_SAME") || "");
    if (localStorageService.getItem("ADDRESS_ID_NOT_SAME")) {
      localStorageService.removeItem("ADDRESS_ID_NOT_SAME");
    }
  }, []);

  useEffect(() => {
    /**
     * Conditions to show Delivery Estimate Toast
     * 1. EDD switch should be enabled
     * 2. At-least one of the cart item should have eddMessage
     * 3. AddressId should not be same
     */
    const canShowToast = EDD?.switchEnabled
      && cartInfo?.cartItems?.some((item: { eddMessage: string }) => item?.eddMessage)
      && addressIdNotSame
      && !cartErrorMessage;
    if (canShowToast) {
      setIsDeliveryEstimateToastVisible(true);
        //to hide toast visibility after 3 seconds
      setTimeout(() => {
        setIsDeliveryEstimateToastVisible(false);
      }, 5000);
    }
  }, [addressIdNotSame, cartErrorMessage]);

  // Redirecting  user to payment screen 2 if earlier payment was done using fresh payment method
  useEffect(() => {
    const isPaymentFailurePage =
        window?.location?.href && window?.location?.href.includes("paymentFailureOrderId");
    if (!isSavedPayment && isPaymentFailurePage && newPaymentFailureEnabled && !showAllPaymentMethods) {
      // used doAppendOrReplaceQueryParam function to not re-append the screen=newPayment queryParam if it already exists in the url
      const url = doAppendOrReplaceQueryParam("screen", "newPayment") || "";
      history.replace(url);
    }
  }, [isSavedPayment]);

  useEffect(() => {
    // scrolling to top on UPI timer screen
    if (upiTimerConfig?.isVisible) {
      window?.scrollTo(0, 0);
    }
    setIsPaymentProcessing(false);
  }, [upiTimerConfig?.isVisible]);

  useMemo(() => {
    // isPaymentProcessing state is for preventing multiple triggers of payment page events when loading state chnages
    if (
      !loading &&
      Object.keys(paymentInfo)?.length !== Object.keys(initialPaymentInfoState)?.length &&
      !isPaymentProcessing
    ) {
      if (paymentScreen === PAYMENT_SCREENS.SAVED) {
        // tracking for payment page load

        // @todo:- we need to remove getIsSavedMethodsDisplayed method from here.
        let { savedMethodsAvailable } = getIsSavedMethodsDisplayed(cartInfo, paymentInfo, upiIntentList);
        // When user came from address page and user have only saved upi intent in last_payment_info then we will not update the savedMethodLength.
        if (!(isApp && savedMethodsAvailable.length === 0 && toLowerCase(paymentInfo?.lastPaymentInfo?.paymentMode) === toLowerCase(PAYMENT_MODES.UPI_INTENT))) {
          setSavedMethodLength(savedMethodsAvailable?.length);
        }
        // redirecting to All payment screen when flow is either wallet or giftcard, after fetching paymentInfoCreation Api
        if (!loading && savedMethodsAvailable?.length === 0 && flow != PAYMENT_FLOWS.CHECKOUT) {
          let url = doAppendQueryParam("screen", "newPayment");
          history.replace(url);
        }
      }
    }
  }, [paymentScreen, loading, upiIntentList.length]);

  //UpiIntent app availability handling on Mweb
  useEffect(() => {
    /**
     * if we are showing all upi apps then there is no need of checking the app
     * for Mweb only.
     */
    if (
      checkAllUpiIntentVisibilityOnWeb({
        availablePaymentMethods,
        isExperimentEnable: UpiIntentMweb.experimentEnabled && UpiIntentMweb.switchEnabled,
        cashFreePaymentGateway,
      })
    ) {
      setIsGpayIntentLoading(false);
      return;
    }
      /**
       * for apps razorpay script should not load to detect upi apps
       * as upi apps is detected by app callback (webview)
       */
      const isUpiIntentAvailableOnWeb = checkUpiIntentVisibilityOnWeb({
        availablePaymentMethods,
        cashFreePaymentGateway,
        gPayExperiment,
        setIsGpayIntentLoading,
        isApp,
      });

    if (isUpiIntentAvailableOnWeb) {
      loadUpiIntentForWeb({
        razorPayKey: paymentInfo?.razorPayKey,
        cashFreePaymentGateway,
        setIsGPayIntentAvailable,
        setIsGpayIntentLoading,
        gPayExperiment,
      });
    }
  }, [cashFreePaymentGateway, paymentInfo.razorPayKey, availablePaymentMethods]);

  useEffect(() => {
    setIsOtpVerificationRequired(
      walletOtpVerificationRequired || (isWalletAccordianOpen && isVerificationRequired)
    );
  }, [walletOtpVerificationRequired, isWalletAccordianOpen, isVerificationRequired]);

  /**
   * Note: This is a special block to control browser back
   */
  useEffect(() => {
    const paymentFailureOrderIdParam = query.get("paymentFailureOrderId");
    //backfriction bottomsheet will be visible when user is going from payment to cart page
    if (
      flow == PAYMENT_FLOWS.CHECKOUT &&
      paymentScreen === PAYMENT_SCREENS.SAVED &&
      !paymentFailureOrderIdParam &&
      !upiTimerConfig.isVisible &&
      shippingAddress && // if there's no shipping address then don't push extra url for paymentBackfricction
      window.location.hash !== "#modal" &&// if there is #modal in url then don't push extra url for paymentBackfricction
      query.get("screen") !== "newPayment"
    ) {
      /**
       * push a state to browser history when component mounts
       * window.history.length === 1 is for app
       */
      if (
        PaymentBackFriction?.experimentEnabled &&
        (window.history?.state?.prevUrl != window.location?.href || window.history.length === 1)
      ) {
        window.history?.pushState({ prevUrl: window.location?.href }, "", window.location?.href);
      }

      /**
       * A popstate event is dispatched to the window every time the active history entry changes, such as clicking on the back button (or calling history.back() in JavaScript),
       * Popstate event will be fired only when user has interacted with the page
       */
      window.addEventListener("popstate", handlebackfrictionModal);
    }

    return () => {
      window.removeEventListener("popstate", handlebackfrictionModal);
    };
  }, [paymentScreen, window.location.hash, upiTimerConfig?.isVisible]);

  useEffect(() => {
    let visibleScreen = PAYMENT_SCREENS.SAVED;
    if (currentScreen === "newPayment") {
        visibleScreen = PAYMENT_SCREENS.ALL;
    }
    setPaymentScreen(visibleScreen);
    windowScrollToTop();
  }, [currentScreen]);

  /**
   * When user is not having any savedmethod then
   * redirect to user to payment screen 2
   * Note : this block is only for checkout flow
   */
  useEffect(() => {
    if (
      flow === PAYMENT_FLOWS.CHECKOUT &&
      savedMethodLength === 0 &&
      orderAmount !== 0
    ) {
      if (
        canRedirectToNewPaymentScren ||
        shipTothisAddressClicked
      ) {
        /**
         * Note:- when there is error object in addressDto
         * or when Delivery Estimate toast it shown
         * we are not redirecting user to new payment screen
         */
        if (!cartInfo?.shippingAddress?.error?.errorCode && !isDeliveryEstimateToastVisible) {
          trackDirectlyRedirectUserToNewPaymentPage();
          let url = doAppendQueryParam("screen", "newPayment");
          /**
           * Note: back button is not working on saved payment screen
           * that's why we use settime out .This is very weird issue
           */
          setTimeout(() => {
            history.push(url);
          }, 50);
        }
      }
    }
  }, [flow, savedMethodLength, shipTothisAddressClicked, canRedirectToNewPaymentScren]);

  useEffect(() => {
    const getToastConfig = () => {
      const data = getStorageData(STORAGE_KEYS.REMOVE_COUPON_ID, false);
      removeStorage(STORAGE_KEYS.REMOVE_COUPON_ID, false);
      return JSON.parse(data || "{}");
    };
    const toastConfigData = getToastConfig();
    if (Object.keys(toastConfigData).length) {
      setToastConfig(toastConfigData);
    }
  }, []);

  /**
   * Showing this shimmer when saved and new payment Method
   * shown on one screen.
   */
  if (isPaymentInfoLoading && showAllPaymentMethods) {
    return <CheckoutSinglePageShimmer headerTitle={headerTitle} />;
  }

  return (
    <>
      <PollingStatusPage initialPollTime={paymentInfo?.paymentConversionPollTime} />
      <UpiModalWrapper isVisible={upiTimerConfig?.isVisible}>
        <MobHeader
          title={upiTimerConfig?.headerText}
          onIconClick={upiTimerConfig?.onBackButtonClick}
          fixAtTop
        />
        <Main>
          {upiTimerConfig?.isVisible && (
            <UpiTimerScreenMobile {...upiTimerConfig} history={history} />
          )}
        </Main>
      </UpiModalWrapper>

      <div>
        <PaymentSeo
          title={__SEO_TITLE__}
          canonicalLink={__CANONICAL_LINK__}
          description={__SEO_DESCRIPTION__}
          img={__LOGO__}
        />
        <Wrapper data-testid="payment_page">
          <MobHeader
            title={headerTitle}
            onIconClick={handleBackButtonClick}
            fixAtTop
            dataTestId={dataTestId}
          />
          {!showAllPaymentMethods && (
            <AllSavedPaymentMethod
              isVisible={paymentScreen === PAYMENT_SCREENS.SAVED}
              setIsWalletChecked={setIsWalletChecked}
              setPaymentScreen={setPaymentScreen}
              timerCallback={timerCallback}
              setUpiDetails={setUpiDetails}
              isGPayIntentAvailable={isGPayIntentAvailable}
              loading={loading}
              showAllPaymentMethods={showAllPaymentMethods}
              showFallbackModeSheet={showFallbackModeSheet}
              isGPayIntentLoading={isGPayIntentLoading}
              setShowFallbackModeSheet={setShowFallbackModeSheet}
              isDeliveryEstimateToastVisible={isDeliveryEstimateToastVisible}
              setIsDeliveryEstimateToastVisible={setIsDeliveryEstimateToastVisible}
            />
          )}
          <AllPaymentMethod
            isVisible={paymentScreen === PAYMENT_SCREENS.ALL}
            setIsWalletChecked={setIsWalletChecked}
            timerCallback={timerCallback}
            setUpiDetails={setUpiDetails}
            isGPayIntentAvailable={isGPayIntentAvailable}
            paymentScreen={paymentScreen}
            showAllPaymentMethods={showAllPaymentMethods}
            showFallbackModeSheet={showFallbackModeSheet}
            setShowFallbackModeSheet={setShowFallbackModeSheet}
          />
          {isVerifyOtpVisible && (
            <VerifyOTP
              sendOtpCallback={sendOtpCallback}
              verifyOtpCallback={verifyOtpCallback}
              mobileNumber={mobileNumber}
              isVerifyOtpVisible={isVerifyOtpVisible}
              setIsVerifyOtpVisible={setIsVerifyOtpVisible}
            />
          )}
          {!isPaymentInfoLoading && toastConfig?.message && (
            <Toast
              message={toastConfig?.message || ""}
              isVisible={true}
              leadingIcon={toastConfig?.icon || ""}
              duration={getToastTimer()}
              theme={theme}
            />
          )}
          {showBackFrictionBottomSheet && <BottomSheet {...mobileBackFrictionConfig} />}
        </Wrapper>
      </div>
    </>
  );
};

export default CheckoutPayment;
